import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ActionsProvider } from "./context/ActionsContext";
import Layout from "./components/Layout";
import { Loading } from "./components/shared";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Candidates from "./pages/Candidates";
import CandidateDetail from "./pages/CandidateDetail";
import Transactions from "./pages/Transactions";
import Payees from "./pages/Payees";
import PayeeDetail from "./pages/PayeeDetail";
import Accounts from "./pages/Accounts";
import AccountDetail from "./pages/AccountDetail";
import Advances from "./pages/Advances";
import { DailyReport, PeriodReport, PnLReport, CashFlowReport, OutstandingReport, WeeklyReport, MonthlyReport } from "./pages/Reports";
import AIAssistant from "./pages/AIAssistant";
import MasterData from "./pages/MasterData";
import Users from "./pages/Users";
import Audit from "./pages/Audit";
import Settings from "./pages/Settings";
import Approvals from "./pages/Approvals";
import Reconciliation from "./pages/Reconciliation";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <ActionsProvider>
      <Layout>{children}</Layout>
    </ActionsProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/candidates" element={<Protected><Candidates /></Protected>} />
          <Route path="/candidates/:id" element={<Protected><CandidateDetail /></Protected>} />
          <Route path="/transactions" element={<Protected><Transactions /></Protected>} />
          <Route path="/payees" element={<Protected><Payees /></Protected>} />
          <Route path="/payees/:id" element={<Protected><PayeeDetail /></Protected>} />
          <Route path="/accounts" element={<Protected><Accounts /></Protected>} />
          <Route path="/accounts/:id" element={<Protected><AccountDetail /></Protected>} />
          <Route path="/advances" element={<Protected><Advances /></Protected>} />
          <Route path="/approvals" element={<Protected><Approvals /></Protected>} />
          <Route path="/reports/daily" element={<Protected><DailyReport /></Protected>} />
          <Route path="/reports/weekly" element={<Protected><WeeklyReport /></Protected>} />
          <Route path="/reports/monthly" element={<Protected><MonthlyReport /></Protected>} />
          <Route path="/reconciliation" element={<Protected><Reconciliation /></Protected>} />
          <Route path="/reports/period" element={<Protected><PeriodReport /></Protected>} />
          <Route path="/reports/pnl" element={<Protected><PnLReport /></Protected>} />
          <Route path="/reports/cashflow" element={<Protected><CashFlowReport /></Protected>} />
          <Route path="/reports/outstanding" element={<Protected><OutstandingReport /></Protected>} />
          <Route path="/ai" element={<Protected><AIAssistant /></Protected>} />
          <Route path="/master" element={<Protected><MasterData /></Protected>} />
          <Route path="/users" element={<Protected><Users /></Protected>} />
          <Route path="/audit" element={<Protected><Audit /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
